'use client'

import { useEffect, useState } from 'react'
import { QuoteIcon } from 'lucide-react'
import { useEditorContext } from '@/components/ui/editor'
import { Button } from '@/components/ui/button'
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip'

const Blockquote = () => {
  const { editor, sourceMode } = useEditorContext()
  const [isActive, setIsActive] = useState(false)

  useEffect(() => {
    if (!editor) {
      return
    }

    const updateSelection = () => {
      setIsActive(editor.isActive('blockquote'))
    }

    editor.on('selectionUpdate', updateSelection)
    editor.on('transaction', updateSelection)

    // cleanup
    return () => {
      editor.off('selectionUpdate', updateSelection)
      editor.off('transaction', updateSelection)
    }
  }, [editor])

  const toggleBlockquote = () => {
    editor.chain().focus().toggleBlockquote().run()
  }

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Button
          type="button"
          size="sm"
          variant={isActive ? 'default' : 'ghost'}
          title="Blockquote"
          onClick={toggleBlockquote}
          aria-pressed={isActive}
          disabled={sourceMode}
          tabIndex={-1}>
          <QuoteIcon />
        </Button>
      </TooltipTrigger>
      <TooltipContent>
        <p>Blockquote</p>
      </TooltipContent>
    </Tooltip>
  )
}

export default Blockquote
